/**
 * Scrolls to `targetId` if it's already mounted; otherwise falls back to just past
 * `fallbackId` (typically the hero section). Target sections below the hero are
 * lazy-mounted once they near the viewport, so right after page load they may not
 * exist in the DOM yet — the fallback's bottom edge is where the section will land.
 */
export function scrollToSection(targetId: string, fallbackId: string) {
  if (typeof window === 'undefined') {
    return;
  }

  const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const target = document.getElementById(targetId) ?? document.getElementById(fallbackId);

  if (!target) {
    window.scrollTo({
      top: window.innerHeight,
      behavior,
    });
    return;
  }

  const rect = target.getBoundingClientRect();
  const top = (target.id === fallbackId ? rect.bottom : rect.top) + window.scrollY;

  window.scrollTo({
    top,
    behavior,
  });
}
